// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GithubFilledSvg from "@ant-design/icons-svg/es/asn/GithubFilled";
import AntdIcon from '../components/AntdIcon';

var GithubFilled = function GithubFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: GithubFilledSvg
  }));
};

GithubFilled.displayName = 'GithubFilled';
export default React.forwardRef(GithubFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/GithubFilled.js
// module id = 1261
// module chunks = 0